"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VidCameraOnIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19.678 8.089q.208-.09.421-.089c.472 0 .901.316.901.753v6.494c0 .437-.43.753-.9.753-.141 0-.286-.028-.424-.09l-2.611-1.416V9.499zM4.856 7h9.288C15.17 7 16 7.747 16 8.669v6.662c0 .922-.83 1.669-1.856 1.669H4.856C3.83 17 3 16.253 3 15.331V8.67C3 7.747 3.83 7 4.856 7"/></svg>`
}, props));
VidCameraOnIcon.displayName = 'VidCameraOnIcon';
var _default = exports.default = VidCameraOnIcon;